// extracted by mini-css-extract-plugin
export default {"container":"View_container__woXI5"};